__webpack_require__.b = new URL("./", import.meta.url);;

      // object to store loaded and loading chunks
      // undefined = chunk not loaded, null = chunk preloaded/prefetched
      // [resolve, Promise] = chunk loading, 0 = chunk loaded
      var moduleInstalledChunks = {3: 0,4: 0,"c8": 0,"eh": 0,"xzc": 0,"y2": 0,};
      var moduleInstallChunk = (data) => {
    var __rspack_esm_ids = data.__rspack_esm_ids;
    var moreModules = data.__webpack_modules__;
    var __rspack_esm_runtime = data.__rspack_esm_runtime;
    // add "modules" to the modules object,
    // then flag all "ids" as loaded and fire callback
    var moduleId, chunkId, i = 0;
    for (moduleId in moreModules) {
        if (__webpack_require__.o(moreModules, moduleId)) {
            __webpack_require__.m[moduleId] = moreModules[moduleId];
        }
    }
    if (__rspack_esm_runtime) __rspack_esm_runtime(__webpack_require__);
    for (; i < __rspack_esm_ids.length; i++) {
        chunkId = __rspack_esm_ids[i];
        if (__webpack_require__.o(moduleInstalledChunks, chunkId) && moduleInstalledChunks[chunkId]) {
            moduleInstalledChunks[chunkId][0]();
        }
        moduleInstalledChunks[__rspack_esm_ids[i]] = 0;
    }
    
};

        __webpack_require__.f.j = function (chunkId, promises) {
          // import() chunk loading for javascript
var installedChunkData = __webpack_require__.o(moduleInstalledChunks, chunkId) ? moduleInstalledChunks[chunkId] : undefined;
if (installedChunkData !== 0) { // 0 means "already installed".'
    // a Promise means "currently loading".
    if (installedChunkData) {
        promises.push(installedChunkData[1]);
    } else {
        if (!/^([34d]|c8|eh|he|xzc|y2)$/.test(chunkId)) {
            // setup Promise in chunk cache
            var promise = import("./" + __webpack_require__.u(chunkId)).then(moduleInstallChunk, (e) => {
                if (moduleInstalledChunks[chunkId] !== 0) moduleInstalledChunks[chunkId] = undefined;
                throw e;
            });
            var promise = Promise.race([promise, new Promise((resolve) => {
                installedChunkData = moduleInstalledChunks[chunkId] = [resolve];
            })]);
            promises.push(installedChunkData[1] = promise);
        }
        else moduleInstalledChunks[chunkId] = 0;

    }
}

        }
        
        __webpack_require__.C = moduleInstallChunk;
        // no on chunks loaded
// no HMR
// no HMR manifest
